import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import useEntityId from '@/entities/components/details/hooks/use-entity-id';
import type { BusinessInsightSubsection } from '../../../../onboarding-data.types';
import BusinessDetails from './components/business-details';
import Offices from './components/offices';
import People from './components/people';
import RegistrationDetails from './components/registration-details';
import Registrations from './components/registrations';
import Watchlist from './components/watchlist';
import useOnboardingBusinessInsights from './hooks/use-onboarding-business-insights';
type DecryptedContentProps = {
  onboardingId: string;
  selectedSubsection: BusinessInsightSubsection;
};
const DecryptedContent = t0 => {
  const $ = _c(29);
  const {
    onboardingId,
    selectedSubsection
  } = t0;
  const [openRegistrationId, setOpenRegistrationId] = useState(undefined);
  const entityId = useEntityId();
  const {
    data: insights
  } = useOnboardingBusinessInsights(entityId, onboardingId);
  let t1;
  if ($[0] !== insights?.registrations || $[1] !== openRegistrationId) {
    t1 = insights?.registrations.find(r => r.id === openRegistrationId);
    $[0] = insights?.registrations;
    $[1] = openRegistrationId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const openRegistration = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = registrationId => {
      setOpenRegistrationId(registrationId);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleOpen = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setOpenRegistrationId(undefined);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClose = t3;
  let t4;
  if ($[5] !== insights || $[6] !== selectedSubsection) {
    t4 = (insights?.names || insights?.details) && selectedSubsection === "business-details" && <BusinessDetails names={insights.names} details={insights.details} onClick={handleOpen} />;
    $[5] = insights;
    $[6] = selectedSubsection;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== insights || $[9] !== selectedSubsection) {
    t5 = insights?.people && selectedSubsection === "people" && <People data={insights.people} />;
    $[8] = insights;
    $[9] = selectedSubsection;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== insights || $[12] !== selectedSubsection) {
    t6 = insights?.registrations && selectedSubsection === "registrations" && <Registrations data={insights.registrations} onClick={handleOpen} />;
    $[11] = insights;
    $[12] = selectedSubsection;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== insights || $[15] !== selectedSubsection) {
    t7 = insights?.watchlist && selectedSubsection === "watchlist" && <Watchlist data={insights.watchlist} />;
    $[14] = insights;
    $[15] = selectedSubsection;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== insights || $[18] !== selectedSubsection) {
    t8 = insights?.addresses && selectedSubsection === "offices" && <Offices data={insights.addresses} />;
    $[17] = insights;
    $[18] = selectedSubsection;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== openRegistration) {
    t9 = !!openRegistration && <RegistrationDetails registration={openRegistration} onClose={handleClose} />;
    $[20] = openRegistration;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t10 = <>{t4}{t5}{t6}{t7}{t8}{t9}</>;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
export default DecryptedContent;